export const LIGHT_BACKGROUND_COLOR = "#e6e6e6";
export const LIGHT_BORDER_COLOR = "#e6e6e6";

export const THEME_DEFAULT = "default";
